<template>
  <div>
    <transition name="fade" mode="out-in">
      
      <!-- LIST VIEW -->
      <inventory-type-list
        v-if="viewState === 'list'"
        key="list"
        @create="viewState = 'create'"
        @edit="handleEdit"
        @detail="handleDetail"
      ></inventory-type-list>

      <!-- DETAIL VIEW -->
      <inventory-type-detail
        v-else-if="viewState === 'detail'"
        key="detail"
        :id="selectedId"
        @back="viewState = 'list'"
      ></inventory-type-detail>

      <!-- CREATE/EDIT VIEW -->
      <inventory-type-form
        v-else-if="viewState === 'create' || viewState === 'edit'"
        key="form"
        :initial-data="currentTypeData"
        :countries-list="countriesList"
        :all-sections-list="allSectionsList"
        @cancel="viewState = 'list'"
        @submit="handleFormSubmit"
      ></inventory-type-form>

    </transition>
  </div>
</template>

<script>
// Import Components
import InventoryTypeList from "../components/inventory-types/InventoryTypeList.vue";
import InventoryTypeForm from "../components/inventory-types/InventoryTypeForm.vue";
import InventoryTypeDetail from "../components/inventory-types/InventoryTypeDetail.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    InventoryTypeList,
    InventoryTypeForm,
    InventoryTypeDetail,
  },
  data() {
    return {
      viewState: "list", // list, create, edit, detail
      selectedId: null,
      currentTypeData: null,
    };
  },
  computed: {
    ...mapState("countries", {
        countriesList: state => state.configuredCountries
    }),
    ...mapState("colums", {
        allSectionsList: state => state.dataSections
    }),
  },
  async mounted() {
      await this.loadConfiguredCountries();
      await this.getAllSectionsForConfig();
  },
  methods: {
    ...mapActions("countries", ["loadConfiguredCountries"]),
    ...mapActions("sections", ["listAllSections", "getAllSectionsForConfig"]),
    ...mapActions("inventoryTypes", ["createInventoryType", "updateInventoryType", "filterInventoryType"]),

    async handleEdit(id) {
      this.selectedId = id;
      try {
          const data = await this.filterInventoryType(id);
          this.currentTypeData = data;
          this.viewState = "edit";
      } catch (e) {
          console.error("Error fetching type details", e);
      }
    },
    
    handleCreate() {
        this.selectedId = null;
        this.currentTypeData = null;
        this.viewState = "create";
    },

    handleDetail(id) {
        this.selectedId = id;
        this.viewState = 'detail';
    },

    async handleFormSubmit(payload) {
        let success = false;
        if (this.selectedId) {
             success = await this.updateInventoryType({ id: this.selectedId, data: payload });
             if (success) {
                  // Reload data to reflect changes without leaving the page
                  await this.handleEdit(this.selectedId);
                  this.$notify({
                        type: 'success',
                        title: 'Éxito',
                        text: 'El tipo de inventario se ha actualizado correctamente.'
                  });
             }
        } else {
             success = await this.createInventoryType(payload);
             if (success) {
                this.handleSuccess();
             }
        }
    },

    handleSuccess() {
      this.viewState = "list";
    },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
